import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";

export function NotFoundPage() {
  const onHandleClick = () => {
    window.location.href = "/";
  };

  return (
    <Box textAlign="center">
      <Box width="100%" mt={8}>
        <Typography
          sx={{
            fontSize: "260px",
            fontWeight: "900",
            lineHeight: "100%",
            background: "linear-gradient(180deg, #FFFFFF 36.73%, #ACBBC3 89.58%)",
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            zIndex: "3",
            filter: "drop-shadow(0px 3px 1px #131A61)",
          }}
        >
          404
        </Typography>
      </Box>

      <Box display="flex" flexDirection="column" justifyContent="center" alignItems="center">
        <Typography
          sx={{
            fontSize: "36px",
            fontWeight: "900",
            lineHeight: "44px",
            letterSpacing: "-0.72px",
            background: "linear-gradient(180deg, #FFFFFF 36.73%, #ACBBC3 89.58%)",
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            zIndex: "3",
            filter: "drop-shadow(0px 3px 1px #131A61)",
          }}
        >
          PAGE NOT FOUND
        </Typography>

        <Typography
          sx={{
            fontSize: "36px",
            fontWeight: "900",
            lineHeight: "44px",
            letterSpacing: "-0.72px",
            background: "linear-gradient(180deg, #FFFFFF 36.73%, #ACBBC3 89.58%)",
            backgroundClip: "text",
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            zIndex: "3",
            filter: "drop-shadow(0px 3px 1px #131A61)",
          }}
        >
          The page you’re trying to access does not exist.
        </Typography>

        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          mt={[6, 8, 7, 8, 10]}
          width={[310, 275, 275, 340, 384]}
        >
          <Button
            onClick={onHandleClick}
            sx={{
              display: "flex",
              width: "208px",
              padding: 2,
              borderRadius: "8px",
              background: "#FFF",
              color: "#382053",
            }}
          >
            Back To Homepage
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
